export var Gender;
(function (Gender) {
    Gender["MALE"] = "MALE";
    Gender["FEMALE"] = "FEMALE";
    Gender["OTHER"] = "OTHER";
    Gender["PREFER_NOT_TO_SAY"] = "PREFER_NOT_TO_SAY";
})(Gender || (Gender = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["ACTIVE"] = "ACTIVE";
    MembershipStatus["INACTIVE"] = "INACTIVE";
    MembershipStatus["SUSPENDED"] = "SUSPENDED";
    MembershipStatus["PENDING"] = "PENDING";
    MembershipStatus["TERMINATED"] = "TERMINATED";
})(MembershipStatus || (MembershipStatus = {}));
export var MemberRole;
(function (MemberRole) {
    MemberRole["MEMBER"] = "MEMBER";
    MemberRole["ADMIN"] = "ADMIN";
    MemberRole["TREASURER"] = "TREASURER";
    MemberRole["SECRETARY"] = "SECRETARY";
    MemberRole["BOARD_MEMBER"] = "BOARD_MEMBER";
    MemberRole["COACH"] = "COACH";
    MemberRole["VOLUNTEER"] = "VOLUNTEER";
})(MemberRole || (MemberRole = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PAID"] = "PAID";
    PaymentStatus["PENDING"] = "PENDING";
    PaymentStatus["OVERDUE"] = "OVERDUE";
    PaymentStatus["EXEMPT"] = "EXEMPT";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType["MEMBERSHIP_FEE"] = "MEMBERSHIP_FEE";
    PaymentType["EVENT_FEE"] = "EVENT_FEE";
    PaymentType["DONATION"] = "DONATION";
    PaymentType["OTHER"] = "OTHER";
})(PaymentType || (PaymentType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CASH"] = "CASH";
    PaymentMethod["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethod["CREDIT_CARD"] = "CREDIT_CARD";
    PaymentMethod["PAYPAL"] = "PAYPAL";
    PaymentMethod["SEPA_DEBIT"] = "SEPA_DEBIT";
    PaymentMethod["OTHER"] = "OTHER";
})(PaymentMethod || (PaymentMethod = {}));
export var OutgoingPaymentCategory;
(function (OutgoingPaymentCategory) {
    OutgoingPaymentCategory["RENT"] = "RENT";
    OutgoingPaymentCategory["UTILITIES"] = "UTILITIES";
    OutgoingPaymentCategory["EQUIPMENT"] = "EQUIPMENT";
    OutgoingPaymentCategory["SUPPLIES"] = "SUPPLIES";
    OutgoingPaymentCategory["INSURANCE"] = "INSURANCE";
    OutgoingPaymentCategory["SALARY"] = "SALARY";
    OutgoingPaymentCategory["CONTRACTOR"] = "CONTRACTOR";
    OutgoingPaymentCategory["MARKETING"] = "MARKETING";
    OutgoingPaymentCategory["MAINTENANCE"] = "MAINTENANCE";
    OutgoingPaymentCategory["TRAVEL"] = "TRAVEL";
    OutgoingPaymentCategory["FEES"] = "FEES";
    OutgoingPaymentCategory["OTHER"] = "OTHER";
})(OutgoingPaymentCategory || (OutgoingPaymentCategory = {}));
export var OutgoingPaymentStatus;
(function (OutgoingPaymentStatus) {
    OutgoingPaymentStatus["PENDING"] = "PENDING";
    OutgoingPaymentStatus["PAID"] = "PAID";
    OutgoingPaymentStatus["CANCELLED"] = "CANCELLED";
    OutgoingPaymentStatus["REFUNDED"] = "REFUNDED";
})(OutgoingPaymentStatus || (OutgoingPaymentStatus = {}));
